import PropTypes from 'prop-types'
import React, { useState, useEffect, useCallback } from 'react'
import * as componenteErrorService from '../servicios/componenteErrorService'
import styles from './ComponenteError.module.css'

const ComponenteError = (props) => {
  const [componenteError, setComponenteError] = useState([])
  const [tipoAlert, setTipoAlert] = useState('')

  const errorClass = useCallback((tipo) => {
    let tipoAlert

    if (tipo === 'I') {
      tipoAlert = `alert ${styles.alertComponenteError}`
    } else if (tipo === 'W') {
      tipoAlert = 'alert alert-warning mr-auto ml-auto mt-3'
    } else if (tipo === 'E') {
      tipoAlert = 'alert alert-danger mr-auto ml-auto mt-3'
    } else if (tipo === 'S') {
      tipoAlert = 'alert alert-success mr-auto ml-auto mt-3'
    }

    setTipoAlert(tipoAlert)
    return tipoAlert
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      const { data: componenteError } = await componenteErrorService.BuscarTodos(
        props.tipo,
        props.idAviso
      )
      setComponenteError(componenteError)
      const type = componenteError.map((error) => error.tipo)
      const datoTipo = type[0]
      errorClass(datoTipo)
    }
    fetchData()
  }, [props.tipo, props.idAviso, errorClass])

  return (
    <div className={`row item ${styles.container}`}>
      <div className={tipoAlert}>
        {componenteError.map((error) => (
          <React.Fragment key={error.idAviso}>
            <h2 className="alert-heading">{error.titulo}</h2>
            <p className={styles.errorDetalle}>{error.detalle}</p>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

ComponenteError.propTypes = {
  tipo: PropTypes.string.isRequired,
  idAviso: PropTypes.number.isRequired
}

export default ComponenteError
